import { GlobalResponseObject } from "@gtpl/shared-models/common-models";
import {ReWeighMentModelDto, ReweighmentInfoModel} from './re-weighment-model'
import { ReWeighMentDefectsModel } from "./defects-info-model";

export class ReWeighMentResponseModel extends GlobalResponseObject {
    data?: ReweighmentInfoModel;
    

    constructor(status: boolean, intlCode: number, internalMessage: string, data?: ReweighmentInfoModel){
        super(status, intlCode, internalMessage);
        this.status = status;
        this.intlCode = intlCode;
        this.internalMessage = internalMessage;
        this.data = data;
        

    }
}
